import { apiClient, type Paginated } from '@/core/api';
import type { KeyResult, KeyResultInput, Objective, ObjectiveInput, ObjectiveStatus } from './types';

const OBJECTIVES = '/okr/objectives/';
const KEY_RESULTS = '/okr/key-results/';

export interface ObjectiveListParams {
  page?: number;
  status?: ObjectiveStatus;
  owner?: number;
}

export async function listObjectives(params: ObjectiveListParams = {}): Promise<Paginated<Objective>> {
  const { data } = await apiClient.get<Paginated<Objective>>(OBJECTIVES, { params });
  return data;
}

export async function createObjective(input: ObjectiveInput): Promise<Objective> {
  const { data } = await apiClient.post<Objective>(OBJECTIVES, input);
  return data;
}

export async function updateObjective(id: number, input: Partial<ObjectiveInput>): Promise<Objective> {
  const { data } = await apiClient.patch<Objective>(`${OBJECTIVES}${id}/`, input);
  return data;
}

export async function deleteObjective(id: number): Promise<void> {
  await apiClient.delete(`${OBJECTIVES}${id}/`);
}

export async function createKeyResult(input: KeyResultInput): Promise<KeyResult> {
  const { data } = await apiClient.post<KeyResult>(KEY_RESULTS, input);
  return data;
}

export async function updateKeyResult(id: number, input: Partial<KeyResultInput>): Promise<KeyResult> {
  const { data } = await apiClient.patch<KeyResult>(`${KEY_RESULTS}${id}/`, input);
  return data;
}

export async function deleteKeyResult(id: number): Promise<void> {
  await apiClient.delete(`${KEY_RESULTS}${id}/`);
}
